module.exports = __webpack_public_path__ + "fonts/fontello.068ca2b3.ttf";